import { Box, Typography } from "@mui/material";
import ListOfEntitiesStyles from "./ListOfEntities.styles";

export const ListOfEntities = ({
    title,
    list,
}: {
    title: string;
    list: {
        id: number | string;
        term: string;
        subTerm?: string;
        value: string;
    }[];
}) => {
    const classes = ListOfEntitiesStyles();

    return (
        <>
            <Box className={classes.header}>
                <Typography className={classes.title}>{title}</Typography>
            </Box>
            <Box className={classes.body}>
                {list.map((data) => {
                    return (
                        <Box key={data.id} className={classes.item}>
                            <Box className={classes.termColumn}>
                                <Typography className={classes.term}>{data.term}</Typography>
                                {data?.subTerm && <Typography className={classes.subTerm}>{data.subTerm}</Typography>}
                            </Box>
                            <Typography
                                className={classes.valueColumn}
                                sx={{ color: data.value ? "text.primary" : "text.disabled" }}
                            >
                                {data.value}
                            </Typography>
                        </Box>
                    );
                })}
            </Box>
        </>
    );
};
